import $ from 'jquery';
import Choices from "choices.js";

/**
 * Translation-related functions
 */

/**
 * Translation fixes:
 * - Remove the select placeholder
 * - Reinit Choices
 */
export function convertTranslationLabels() {
    setTimeout(function(){

        // Convert Labels
        const $switchers = $('.gTranslate');
        $switchers.each(function(){
            const $options = $(this).find('option');
            if ( !$options.length ) return;

            // Remove 'Select Language' option
            const $selectOption = $options.filter(':contains("Select Language")');
            $selectOption.remove();

            // Re-init Choices
            const choices = new Choices($(this).find('select')[0], {
                allowHTML: true,
                searchEnabled: false,
                shouldSort: false,
                itemSelectText: ''
            });
        });

        
        
    }, 300);
}

